export default function FaceDown() {
  return (
    <svg
      width='62'
      height='64'
      viewBox='0 0 62 64'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M31 0.655762C48.1211 0.655762 62 14.6889 62 32.0002C62 49.3116 48.1211 63.3447 31 63.3447C23.7115 63.3447 16.8097 60.793 11.3014 56.204C8.24519 53.6584 5.69107 50.5419 3.78962 47.0299C1.3155 42.4592 0 37.3249 0 32.0002C0 14.6889 13.8789 0.655762 31 0.655762ZM31 1.86132C14.5374 1.86132 1.19231 15.3547 1.19231 32.0002C1.19231 37.1213 2.45686 42.0567 4.8355 46.4511C6.66389 49.8281 9.12026 52.8253 12.0595 55.2736C17.3563 59.6863 23.9907 62.1391 31 62.1391C47.4626 62.1391 60.8077 48.6457 60.8077 32.0002C60.8077 15.3547 47.4626 1.86132 31 1.86132ZM42.1861 47.8576C37.2833 40.2242 27.1882 38.0552 19.6386 43.0131C19.3625 43.1944 18.9933 43.1151 18.8139 42.8359C18.6346 42.5567 18.7131 42.1834 18.9892 42.0021C27.091 36.6815 37.9245 39.0091 43.1861 47.201C43.3654 47.4802 43.2869 47.8535 43.0108 48.0349C42.7347 48.2162 42.3655 48.1368 42.1861 47.8576Z'
        fill='#33820D'
      />
      <path
        d='M22.0576 19.342V27.529C22.0576 27.8619 22.3245 28.1317 22.6538 28.1317C22.983 28.1317 23.2499 27.8619 23.2499 27.529V19.342C23.2499 19.0091 22.983 18.7393 22.6538 18.7393C22.3245 18.7393 22.0576 19.0091 22.0576 19.342Z'
        fill='#33820D'
      />
      <path
        d='M39.3357 19.342V27.529C39.3357 27.8619 39.6026 28.1317 39.9318 28.1317C40.2611 28.1317 40.528 27.8619 40.528 27.529V19.342C40.528 19.0091 40.2611 18.7393 39.9318 18.7393C39.6026 18.7393 39.3357 19.0091 39.3357 19.342Z'
        fill='#33820D'
      />
    </svg>
  );
}
